import { SessionPage } from "@/pages/SessionPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/session/")({
  component: SessionPage,
});
